var render = function render(){var _vm=this,_c=_vm._self._c;return _c('treeselect',{attrs:{"multiple":true,"options":_vm.options,"disable-branch-nodes":true,"search-nested":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})
}
var staticRenderFns = []

export { render, staticRenderFns }